import React, { useState, useEffect } from "react";
import { FaGripVertical } from "react-icons/fa";
import ShiftCard from "./ShiftCard";

const ShiftGridDay = ({

  // DAY
  currentDay,

  // DATA
  shifts,
  selectedTimeSchema,

  allEmployees,
  allProjects,
  allAbsenceRules,

  // FILTERS
  selectedEmployee,
  selectedProject,

  // DELETE MODE
  deleteMode,
  deleteType,

  selectedShiftIds,
  selectedDates,

  setSelectedShiftIds,
  setSelectedDates,

  // SHIFT EDITING
  setIsEditing,
  setEditWorksession,
  setShiftFormData,
  setSelectEmployeePopupVisible,

  // PERMISSIONS
  canEditShifts,

  // HELPERS
  getWholeShiftAbsence,

  styleForVariant,
  badgeForVariant,
  applicationBadge,
  buildTooltip,

  onMoveShift,

}) => {

  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isDraggingShift, setIsDraggingShift] = useState(false);
  const [isCopyModifierHeld, setIsCopyModifierHeld] = useState(false);
  const [isDroppingShift, setIsDroppingShift] = useState(false);

  const currentDayISO =
    currentDay.toISOString().split("T")[0];

    useEffect(() => {
      const handleStart = () => {
        setIsDraggingShift(true);
      };

      const handleEnd = () => {
        setIsDraggingShift(false);
      };

      window.addEventListener(
        "shift-drag-start",
        handleStart
      );

      window.addEventListener(
        "shift-drag-end",
        handleEnd
      );

      return () => {

        window.removeEventListener(
          "shift-drag-start",
          handleStart
        );

        window.removeEventListener(
          "shift-drag-end",
          handleEnd
        );
      };
    }, []);

    useEffect(() => {
      const style =
        document.createElement("style");

      style.innerHTML = `
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `;

      document.head.appendChild(style);

      return () => {
        document.head.removeChild(style);
      };

    }, []);



  const shiftsForDay = shifts.filter((shift) => {

    if (
      shift.timeSchema !== selectedTimeSchema
    ) {
      return false;
    }

    if (!shift?.date) {
      return false;
    }

    const d = new Date(shift.date);

    if (isNaN(d)) {
      return false;
    }

    return (
      d.toISOString().split("T")[0]
      === currentDayISO
    );
  });

  return (
    <div
        className="week-shifts"
        style={{
            position: "relative",
        }}
        onDragOver={(e) => {
            e.preventDefault();

            if (!isDraggingOver) {
                setIsDraggingOver(true);
            }

        }}
        onDragLeave={(e) => {
            // lämnat hela kolumnen
            if (
                !e.currentTarget.contains(
                e.relatedTarget
                )
            ) {
                setIsDraggingOver(false);
            }
        }}
        onDrop={async (e) => {

            e.preventDefault();

            setIsDraggingOver(false);

            window.dispatchEvent(
              new Event("shift-drag-end")
            );

            const shiftId =
                e.dataTransfer.getData("shiftId");

            if (!shiftId) {
                return;
            }

            const copyMode =
                e.altKey ||
                e.ctrlKey ||
                e.metaKey;

            // COPY = SHOW LOADING + WAIT
            if (copyMode) {

              setIsDroppingShift(true);

              try {

                await onMoveShift({
                  shiftId,
                  newDate: currentDayISO,
                  copyMode: true,
                });

              } finally {

                setIsDroppingShift(false);
              }

              return;
            }

            // NORMAL MOVE = NO LOADING
            onMoveShift({
              shiftId,
              newDate: currentDayISO,
              copyMode: false,
            });
        }}
        onDragEnd={() => {
            window.dispatchEvent(
              new Event("shift-drag-end")
            );
            setIsDraggingShift(false);
        }}
        >

     {isDraggingOver && (
        <div
            style={{
            position: "absolute",
            inset: 0,

            background:
                "rgba(59,130,246,0.10)",

            border:
                "2px dashed #3B82F6",

            borderRadius: 12,

            pointerEvents: "none",

            zIndex: 1,

            transition:
                "all 0.15s ease",
            }}
        />
      )}

      {shiftsForDay.length
        ? shiftsForDay.map((shift, index) => {

            if (
              selectedEmployee !== "" &&
              !(
                Array.isArray(shift.employees) &&
                shift.employees.some(
                  (emp) =>
                    emp.employeeId
                    === selectedEmployee
                )
              )
            ) {
              return null;
            }

            if (
              selectedProject &&
              selectedProject.length !== 0 &&
              selectedProject !== shift.project
            ) {
              return null;
            }

          const employeeList =
            Array.isArray(shift.employees) &&
            shift.employees.length > 0
              ? shift.employees
              : [
                  {
                    employeeId: null,
                    overtime: [],
                    breaks: [],
                    absences: [],
                  },
                ];

            const hasAnyEmployeeId =
              employeeList.some(
                (e) => !!e?.employeeId
              );

            const hasOpenSlots =
              employeeList.some(
                (e) => !e?.employeeId
              );

            const isOpenForApplications =
              shift.allowApplications &&
              !hasAnyEmployeeId &&
              hasOpenSlots;

            const missing = {
              project: !shift.project,
              start: !shift.startTime,
              end: !shift.endTime,
              employees: !hasAnyEmployeeId,
            };

            const variant =
              (!isOpenForApplications &&
                missing.employees) ||

              (!isOpenForApplications &&
                missing.project) ||

              (!isOpenForApplications &&
                missing.start) ||

              (!isOpenForApplications &&
                missing.end)

                ? "red"
                : null;

            const baseBg =
              shift.isPublished
                ? "whitesmoke"
                : "white";

            const start =
              shift.startTime || "—";

            const end =
              shift.endTime || "—";

            const projectName =
              allProjects.find(
                (project) =>
                  project._id ===
                  String(shift.project)
              )?.name || "N/A";

            const tooltip =
              variant
                ? buildTooltip(
                    missing,
                    variant
                  )
                : undefined;

  
            // NORMAL SHIFT CARDS
            return (
            <div
                key={shift._id}
                data-shift-group={shift._id}
            >
                {employeeList.map(
                (employee, empIndex) => (
                    <ShiftCard
                    key={`${index}-${empIndex}`}
                    shift={shift}
                    employee={employee}
                    empIndex={empIndex}

                    shiftGroupId={shift._id}

                    selectedEmployee={
                        selectedEmployee
                    }

                    allEmployees={
                        allEmployees
                    }

                    allProjects={
                        allProjects
                    }

                    allAbsenceRules={
                        allAbsenceRules
                    }

                    selectedShiftIds={
                        selectedShiftIds
                    }

                    selectedDates={
                        selectedDates
                    }

                    deleteMode={deleteMode}

                    deleteType={deleteType}

                    setSelectedShiftIds={
                        setSelectedShiftIds
                    }

                    setSelectedDates={
                        setSelectedDates
                    }

                    setIsEditing={
                        setIsEditing
                    }

                    setEditWorksession={
                        setEditWorksession
                    }

                    setShiftFormData={
                        setShiftFormData
                    }

                    setSelectEmployeePopupVisible={
                        setSelectEmployeePopupVisible
                    }

                    getWholeShiftAbsence={
                        getWholeShiftAbsence
                    }

                    employeeList={
                        employeeList
                    }

                    shiftIndex={index}

                    variant={variant}

                    tooltip={tooltip}

                    baseBg={baseBg}

                    start={start}

                    end={end}

                    projectName={
                        projectName
                    }

                    isOpenForApplications={
                        isOpenForApplications
                    }

                    styleForVariant={
                        styleForVariant
                    }

                    badgeForVariant={
                        badgeForVariant
                    }

                    applicationBadge={
                        applicationBadge
                    }
                    />
                )
                )}
            </div>
            );
          })
        : null}

      {canEditShifts && (
        <div className="add-shift-button-container">
          <button
            type="button"
            onClick={() => {

              setIsEditing(false);

              setShiftFormData({
                employees: [
                  {
                    employeeId: "",

                    overtime: [],

                    absence: [],

                    breaks: [],
                  },
                ],

                project: "",

                additionalProject: "",

                userSelection: "",

                date:
                  currentDay
                    .toISOString()
                    .split("T")[0],

                allowApplications: false,

                startTime: "",

                endTime: "",
              });

              setSelectEmployeePopupVisible(
                true
              );
            }}
            className="add-shift-button"
          >
            +
          </button>
        </div>
      )}

      {isDraggingShift && (
        <div
          style={{
            position: "fixed",
            bottom: 24,
            left: "50%",
            transform: "translateX(-50%)",

            background: "rgba(17,24,39,0.92)",
            color: "white",

            padding: "10px 16px",

            borderRadius: 10,

            fontSize: 14,
            fontWeight: 500,

            zIndex: 999999,

            pointerEvents: "none",

            backdropFilter: "blur(8px)",

          }}
        >
          Håll in{" "}
          {/Mac|iPhone|iPad|iPod/.test(
            navigator.platform
          )
            ? "⌥ Option"
            : "Ctrl"}{" "}
          vid släpp för att kopiera passet
        </div>
      )}

      {isDroppingShift && (
        <div
          style={{
            position: "absolute",
            inset: 0,

      

            backdropFilter: "blur(2px)",

            borderRadius: 12,

            zIndex: 20,

            display: "flex",
            alignItems: "center",
            justifyContent: "center",

            pointerEvents: "none",
          }}
        >
          <div
            style={{
              width: 32,
              height: 32,

              border:
                "3px solid rgba(59,130,246,0.20)",

              borderTop:
                "3px solid #3B82F6",

              borderRadius: "50%",

              animation:
                "spin 0.7s linear infinite",
            }}
          />
        </div>
      )}

    </div>
    
  );
};

export default ShiftGridDay;